import React, { ReactNode } from 'react';
import { Typography } from '@mui/material';

interface SectionTitleProps {
  children: ReactNode;
}

/**
 * Intertitre du formulaire de qualification. La hauteur de ligne de `overline` et l'espacement
 * du Stack parent l'éloignaient trop des champs qu'il annonce : on le resserre sur eux.
 */
export default function SectionTitle({ children }: SectionTitleProps) {
  return (
    <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1.5, mb: -1 }}>
      {children}
    </Typography>
  );
}
